let timeout;

export function debounce(callback, delay = 250) {
    clearTimeout(timeout);
    timeout = setTimeout(callback, delay);
}